<template>
  <div>
    <finance-drawer
      title="对账明细"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="countingNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div>
        <jr-search2
          ref="searchForm"
          :form-list="formList"
          :search-value.sync="queryForm"
          :loading="loading"
          @search="handleSearch"
          @reset="handleReset"
        />
        <div class="export-box">
          <div class="header-content">
            <div>
              <span>{{countData.merchantName}}</span>
              <span>{{countData.channelTypeDesc}}</span>
            </div>
            <div class="flex">
              <div>
                <div style="margin-bottom: 10px;">财务系统交易总额:{{countData.finTotalTradeAmount | toFenThousandsAndFloat}}元</div>
                渠道交易总额:{{countData.thirdTotalTradeAmount | toFenThousandsAndFloat}}元
              </div>
              <div style="margin-left: 10px;">
                <div style="margin-bottom: 10px;">手续费:{{countData.finTotalFeeAmount | toFenThousandsAndFloat}}元</div>
                手续费:{{countData.thirdTotalFeeAmount | toFenThousandsAndFloat}}元
              </div>
            </div>
          </div>
          <template v-if="$has('FWS-DZZX-DZSK-DC')">
            <page-export-button
              buttonText="导出"
              exportServe="fin_counting_tradeReceiptReport"
              :isLimit="true"
              :exportParams="exportParams"
              trackCode='tradeListReceipt-3'
            />
          </template>
        </div>
        <el-table
          border
          row-class-name="table-row"
          header-row-class-name="table-header-cell"
          :data="list"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column prop="date" width="150">
            <el-table-column prop="matchStatus" label="匹配状态" min-width="1" align="center">
              <template slot-scope="{row}">
                <span :class="{'text-red': row.matchStatus === 0}">{{row.matchStatusDesc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="交易时间" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.tradeTime | formatTime}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="财务系统数据" align="center">
            <el-table-column prop="finRequestNo" label="商户请求号" min-width="1" />
            <el-table-column prop="docNo" label="收款单编号" min-width="1" />
            <el-table-column prop="orderNumber" label="业务订单号" min-width="1" />
            <el-table-column label="交易金额(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.finTradeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="手续费(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.finFeeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="finTypeDesc" label="交易类型" min-width="1" />
          </el-table-column>
          <el-table-column label="渠道交易数据" align="center">
            <el-table-column prop="thirdRequestNo" label="商户请求号" min-width="1" />
            <el-table-column prop="thirdOrderNo" label="渠道订单号" min-width="1" />
            <el-table-column label="交易金额(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.thirdTradeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="渠道手续费(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.thirdFeeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="完成时间" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.thirdFinishTime | formatTime}}</div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="flex flex-justify-end" style="margin-top: 8px">
          <pagination
            :total="total"
            :current-page="queryForm.page"
            :size="queryForm.limit"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </finance-drawer>
  </div>
</template>
<script>
import { getTradeReceiptDetailList, getDetailLookUpStat } from '@/api/counting';

const queryFormDefault = {
  page: 1,
  limit: 20,
  matchStatus: '',
  docNo: '',
  orderNumber: '',
  thirdOrderNo: '',
  finType: '',
};

export default {
  props: {
    countingNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryForm: { ...queryFormDefault },
      loading: false,
      list: [],
      total: 0,
      formList: [
        {
          label: '匹配状态',
          prop: 'matchStatus',
          component: 'select',
          dictionaryPath: '/finance/finance-counting/CountMatchStatusEnum',
        },
        {
          label: '收款单编号',
          prop: 'docNo',
          component: 'input',
          attrs: {
            placeholder: '请输入',
          },
        },
        {
          label: '业务单编号',
          prop: 'orderNumber',
          component: 'input',
          attrs: {
            placeholder: '请输入',
          },
        },
        {
          label: '交易类型',
          prop: 'finType',
          component: 'select',
          dictionaryPath: '/finance/finance-counting/CountFinTypeEnum',
        },
        {
          label: '渠道订单号',
          prop: 'thirdOrderNo',
          component: 'input',
          attrs: {
            placeholder: '请输入',
          },
        },
      ],
      countData: {},
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
        countingNo: this.countingNo,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.queryForm = { ...queryFormDefault };
        this.loading = false;
        this.getList();
        this.getDetailLookUpStat();
      });
    },
    async getDetailLookUpStat() {
      try {
        const params = {
          ...this.queryForm,
          countingNo: this.countingNo,
        };
        const res = await getDetailLookUpStat(params);
        this.countData = res.data || {};
      } catch (error) {
        this.countData = {};
      }
    },
    // 获取交易明细
    async getList() {
      try {
        const params = {
          ...this.queryForm,
          countingNo: this.countingNo,
        };
        this.loading = true;
        const res = await getTradeReceiptDetailList(params);
        this.list = res?.data || [];
        this.total = res.totalCount ?? 0;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.total = 0;
        this.loading = false;
      }
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params };
      this.queryForm.page = 1;
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = { ...queryFormDefault };
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.export-box {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: baseline;
  span {
    margin-right: 15px;
  }
}
</style>
